var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyLogoOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    transform: "matrix(-1 0 0 1 56 0)",
    fill: "#D0E5EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 45.3224V27H39V53.7566C43.3401 51.9006 47.1163 48.9797 50 45.3224ZM36 54.8405V22.2979V12H20V22.2979V54.8405C22.5348 55.5949 25.2201 56 28 56C30.7799 56 33.4652 55.5949 36 54.8405ZM16.9997 53.7565L16.998 22H5.99805L5.99959 45.3219C8.88326 48.9794 12.6594 51.9004 16.9997 53.7565Z",
    fill: "#AACED9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogoOne);
export default __webpack_public_path__ + "static/media/company-logo-one.7668b1fe26fd6672d7880f2aac31fe33.svg";
export { ForwardRef as ReactComponent };